import { useContext, useState } from "react";
import { Box, Button, Chip, Stack, Textarea, Typography } from "@mui/joy";

import StarRating from "../../components/StarRating";
import { LayoutContext } from "../../context";
import { APISaveDraftsmanQualityReview } from "../../api";

// Панель оценки отделом качества работы чертёжника по событию.
// Балл 1..5; при оценке НИЖЕ 5 обязателен комментарий (что не так).
export default function QualityReviewPanel({ item, onSaved }) {
    const { notify } = useContext(LayoutContext);

    const existing = item?.quality_review || null;
    // Оценивать можно только завершённую работу.
    const canRate = !!(item?.is_completed || item?.draftsmen_event?.is_completed);

    const [score, setScore]     = useState(existing?.score || 0);
    const [comment, setComment] = useState(existing?.comment || "");
    const [saving, setSaving]   = useState(false);
    const [error, setError]     = useState("");

    // Поле комментария показываем только при оценке ниже 5.
    const needComment = score > 0 && score < 5;

    const handlePick = (val) => {
        setScore(val);
        setError("");
        if (val === 5) setComment("");   // при 5 комментарий не нужен
    };

    const handleSave = async () => {
        if (!score) {
            setError("Поставьте оценку от 1 до 5");
            return;
        }
        if (needComment && !comment.trim()) {
            setError("При оценке ниже 5 комментарий обязателен — опишите, что не так");
            return;
        }

        setSaving(true);
        setError("");
        try {
            const data = await APISaveDraftsmanQualityReview(item.id, {
                score,
                comment: comment.trim(),
            });
            const review = data?.review || null;
            onSaved?.(review);
            if (review) {
                setScore(review.score);
                setComment(review.comment || "");
            }
            notify?.("Оценка сохранена", "success");
        } catch (e) {
            const msg =
                e?.response?.data?.comment ||
                e?.response?.data?.detail ||
                "Не удалось сохранить оценку";
            setError(msg);
            notify?.(msg, "danger");
        } finally {
            setSaving(false);
        }
    };

    return (
        <Box sx={{ mt: 1, pt: 1.5, borderTop: "1px solid", borderColor: "divider" }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                sx={{ mb: 0.5, flexWrap: "wrap", gap: 1 }}
            >
                <Typography level="title-md">Оценка отдела качества</Typography>
                {existing?.rater_name && (
                    <Chip size="sm" variant="soft" color="neutral">
                        Оценил: {existing.rater_name}
                    </Chip>
                )}
            </Stack>

            <StarRating value={score} onChange={canRate ? handlePick : undefined} size="medium" />

            {!canRate && (
                <Typography level="body-xs" color="warning" sx={{ mt: 0.75 }}>
                    Оценить можно только после завершения работы чертёжником.
                </Typography>
            )}

            {needComment && (
                <Textarea
                    minRows={2}
                    maxRows={5}
                    placeholder="Что не так? (обязательно при оценке ниже 5)"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    sx={{ mt: 1 }}
                />
            )}

            {error && (
                <Typography level="body-xs" color="danger" sx={{ mt: 0.75 }}>
                    {error}
                </Typography>
            )}

            <Button
                size="sm"
                variant="solid"
                color="primary"
                loading={saving}
                disabled={!score || !canRate}
                onClick={handleSave}
                sx={{ mt: 1 }}
            >
                {existing ? "Обновить оценку" : "Сохранить оценку"}
            </Button>
        </Box>
    );
}